/**
 * Bilingual copy and shared tokens for the Voices of Impact NY networking
 * directory. Kept out of the page and card components so the markup files stay
 * layout-only and the strings are editable in one place.
 */

/**
 * Google Apps Script web-app endpoint that appends each introduction request
 * to the Association's spreadsheet. When blank, requests fall back to an email
 * to CONTACT_EMAIL.
 */
export const INTRO_SHEET_URL =
  'https://script.google.com/macros/s/AKfycbzG_BiMq_VHKVkDH_U1JFkDi9aw84wL5nB-tFlH2Gvs8fZpo5ta1nypS4JZf8XsCYHNhA/exec'

export const CONTACT_EMAIL = 'info@honduranamerican.org'

export const GOLD = '#c9a227'
export const NAVY = '#0b1f3f'

export const NETWORKING_COPY = {
  EN: {
    back: 'Back to event',
    eyebrow: 'Voices of Impact · New York City',
    title: 'Guest Networking Directory',
    intro:
      'Everyone in this directory attended Voices of Impact and opted in to keep the conversation going. Browse the room, then request an introduction — the Association passes your note along, so no one’s inbox is published here.',
    privacy:
      'No email addresses are shown. Requests are reviewed by the Association before an introduction is made.',
    searchLabel: 'Search guests',
    searchPlaceholder: 'Search by name, role, or organization',
    all: 'All',
    countOne: 'guest',
    countMany: 'guests',
    empty: 'No guests match your search.',
    clear: 'Clear search',
    lookingFor: 'Open to',
    boardBadge: 'HAA Board',
    linkedin: 'LinkedIn',
    website: 'Website',
    feature: 'Feature',
    requestIntro: 'Request an introduction',
    introTo: 'Request an introduction to',
    formIntro:
      'Tell us a little about yourself and why you’d like to connect. We’ll forward your note and let you know when it’s been passed along.',
    yourName: 'Your name',
    yourEmail: 'Your email',
    yourOrg: 'Organization or company',
    yourRole: 'Your role or title',
    yourLink: 'LinkedIn or website',
    yourLinkPlaceholder: 'linkedin.com/in/yourname',
    yourLinkHelp:
      'Optional, but it helps the guest know who they are meeting.',
    message: 'Why would you like to connect?',
    messagePlaceholder:
      'A sentence or two about what you’d like to discuss or explore together.',
    required: 'Required',
    cancel: 'Cancel',
    send: 'Send request',
    sending: 'Sending…',
    successTitle: 'Request sent',
    successText:
      'Thank you. The Association has your request and will pass it along to',
    done: 'Close',
    fallbackNote: 'Your email app will open with the request ready to send.',
    footer: 'Hosted by the Honduran-American Association',
  },
  ES: {
    back: 'Volver al evento',
    eyebrow: 'Voices of Impact · Ciudad de Nueva York',
    title: 'Directorio de Networking',
    intro:
      'Todas las personas en este directorio asistieron a Voices of Impact y decidieron seguir la conversación. Explore la sala y solicite una presentación: la Asociación hace llegar su mensaje, por lo que aquí no se publica ningún correo.',
    privacy:
      'No se muestran correos electrónicos. La Asociación revisa cada solicitud antes de hacer una presentación.',
    searchLabel: 'Buscar invitados',
    searchPlaceholder: 'Buscar por nombre, cargo u organización',
    all: 'Todos',
    countOne: 'invitado',
    countMany: 'invitados',
    empty: 'Ningún invitado coincide con su búsqueda.',
    clear: 'Limpiar búsqueda',
    lookingFor: 'Abierto a',
    boardBadge: 'Junta HAA',
    linkedin: 'LinkedIn',
    website: 'Sitio web',
    feature: 'Reportaje',
    requestIntro: 'Solicitar una presentación',
    introTo: 'Solicitar una presentación con',
    formIntro:
      'Cuéntenos brevemente sobre usted y por qué desea conectar. Haremos llegar su mensaje y le avisaremos cuando se haya enviado.',
    yourName: 'Su nombre',
    yourEmail: 'Su correo electrónico',
    yourOrg: 'Organización o empresa',
    yourRole: 'Su cargo o título',
    yourLink: 'LinkedIn o sitio web',
    yourLinkPlaceholder: 'linkedin.com/in/sunombre',
    yourLinkHelp:
      'Opcional, pero ayuda a que el invitado sepa a quién va a conocer.',
    message: '¿Por qué le gustaría conectar?',
    messagePlaceholder:
      'Una o dos frases sobre lo que le gustaría conversar o explorar juntos.',
    required: 'Obligatorio',
    cancel: 'Cancelar',
    send: 'Enviar solicitud',
    sending: 'Enviando…',
    successTitle: 'Solicitud enviada',
    successText:
      'Gracias. La Asociación recibió su solicitud y la hará llegar a',
    done: 'Cerrar',
    fallbackNote:
      'Se abrirá su aplicación de correo con la solicitud lista para enviar.',
    footer: 'Organizado por la Asociación Hondureño-Americana',
  },
}

export type NetworkingCopy = (typeof NETWORKING_COPY)['EN']
